import { FC } from 'react';

const Loading: FC = () => {
  return (
    <>
      <div className="w-full relative h-2 bg-off-navy rounded-full justify-center align-middle px-2">
        <div className="bg-navy h-full w-1/5 absolute block rounded-full animate-loading"></div>
      </div>
    </>
  );
};

export default Loading;
